import { createSelector } from '@ngrx/store';

import join from 'lodash/join';
import map from 'lodash/map';

import { DecoratorsConstant as DC, TEMPLATES } from '../../const';
import { IDecorationCitation, UnnumberedCitation } from '../../models';
import { getCitation } from './get.citations';
import { Parser } from '../../../../utils';
import { getIsEditable } from './get.iseditable';

export const getUnnumberCitationContent = (props: { heading: string }) =>
  createSelector(
    [getCitation, getIsEditable],
    (citations: IDecorationCitation, isEditable): string => {
      const { unnumbered_references, unnumberReferencePrefix } = citations;
      const headerString = `<div contenteditable="false" class="d-flex static-labelnames">
    <h5 class="m-0 tab-heading" contenteditable="false">${props.heading}</h5>
    <span class="numberCircle" contenteditable="false"> ${unnumbered_references.length} </span>
  </div>`;
      const unnumberedReferencesString = join(
        map(unnumbered_references, (reference: UnnumberedCitation) => {
          const content = new DOMParser()
            .parseFromString(reference.citationString, 'text/html')
            .body.querySelector(
              `[property="${DC.CITATION_PREF_LABEL}"]`
            ).innerHTML;

          return new Parser().interpolate(TEMPLATES.unnumberedTemplate, {
            citationId: reference.citationId,
            content,
            hideShowClass: !isEditable ? 'hide-action-icons' : '',
            unnumRefPrefix: unnumberReferencePrefix,
            isEditable,
          });
        }),
        ''
      );

      return `${headerString}${unnumberedReferencesString}`;
    }
  );
